<template>
  <div class="tabs">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      @click="selectTab(tab.id)"
      :class="{ active: selectedTab === tab.id }"
    >
      {{ tab.name }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedTab: this.value
    };
  },
  watch: {
    value() {
      this.selectedTab = this.value;
    }
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
      this.$emit("input", tab);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  button {
    background-color: transparent;
    margin-bottom: 0px;
    padding: 0 0 4px;
    color: var(--dark-40);
    font-size: 14px;
    border: none;
    border-bottom: 2px solid transparent;

    cursor: pointer;
    transition: 0.2s all;

    &:hover {
      color: var(--brand);
    }
    &.active {
      border-color: var(--brand);
      color: var(--brand);
    }
  }
}
</style>
